<template>

    <div>
        <button v-if="moduleFree == '0'" @click="showFullPdf()" class="btn btn-outline-primary btn-sm btn-fullscreen" title="Agrandar - Achicar"><i :class="classIcon"></i> {{ fulltText }}</button>
        <div class="w-100 text-center container-video d-flex justify-content-center align-items-center" v-if="quizId == ''"> 
            <img src="@/assets/imgs/spinner.webp" class="img-fluid waiting-img-lesson" />
        </div>
        <div class="w-100 text-center container-lesson" :class="fullpdf" v-show="quizId != ''" id="material">  
            <div style="position: relative;">
                <vue-countdown v-if="counterFinish != ''" :time="counterFinish" v-slot="{ hours, minutes, seconds }" @end="onCountdownEnd" class="countdown">
                    <i class="las la-stopwatch"></i> {{ hours }} : {{ minutes }} : {{ seconds }}
                </vue-countdown>
                <div class="container-question initial-quiz in d-flex justify-content-center align-items-center" id="initial">
                    <div v-if="moduleFree == '1'" class="">
                        <payment-cart v-if="profRef != ''" :profRef="profRef" :couserRef="couserRef" :publishTitle="publishTitle" :moduleName="moduleName" :lessonTitle="titleClass" :moduleId="moduleId" :realPriceInter="realPriceInter" :realPriceLocal="realPriceLocal"></payment-cart>
                    </div>  
                    <div v-if="moduleFree == '2'">
                        <h1 class="text-center text-blue"><i class="las la-ban"></i></h1>
                        <p><b>Podrás acceder al contenido una vez realices el pago.</b></p>
                    </div>
                    <div class="h-100" v-if="moduleFree == '0'">
                        <h3 class="mb-5 mt-5">{{titleClass}}</h3>
                        <p v-if="timeQuiz > 0"><i class="las la-stopwatch"></i> Tendrás {{timeQuiz}} minutos para realizarlo.</p>
                        <p>El cuestionario consta de {{questions.length}} preguntas.</p>
                        <p v-if="okPoints != '0'">Cada pregunta otorga un puntaje y para aprobar el cuestionario deberás alcanzar al menos {{okPoints}} puntos.</p>
                        <div class="mt-5 pb-5">
                            <button class="btn btn-outline-primary btn-sm" @click="startQuiz()">Comenzar Cuestionario</button>
                        </div>
                    </div>
                </div>
                <div class="container-question" v-for="q in questions" :key="q.id" :id="'q-'+q.id">
                    <div class="h-100">  
                        <div class="question">
                            <p :id="'quest-' + q.id">{{q.question}}</p>
                            <div class="question-adjunt h-auto" v-if="q.questionType == 2">
                                <p>"{{q.description}}"</p>
                            </div>
                            <div class="question-adjunt" v-if="q.questionType == 3">
                                <img :src="q.imgQuizURL" class="img-fluid">
                            </div>
                            <div class="question-adjunt" v-if="q.questionType == 4">
                                <vue-vimeo-player v-if="q.videoFile != ''" ref="player" :video-id="q.videoFile" :options='optionsVimeo'/>
                            </div>
                        </div>
                        <div class="options">
                            <div class="option" v-for="a in q.optionsAnswers" :key="a.id" :id="'a-'+a.id" @click="selectOption(a.id, a.correct, q.points, q.id)">
                                <p>{{a.answer}}</p>
                            </div>
                        </div>
                        <div class="mt-5 pb-5">
                            <button class="btn btn-outline-primary btn-sm" @click="nextQuestion(q.id)">Siguiente</button>
                        </div>
                    </div>
                </div>
                <div class="container-question finish-quiz d-flex justify-content-center align-items-center" id="finish">
                    <div class="h-100">
                        <h3 class="mb-2 mt-5">{{titleClass}}</h3>
                        <img v-show="quizOk" src="@/assets/imgs/happy.webp" class="img-fluid w-25 quiz-face-finish" alt="">
                        <img v-show="!quizOk" src="@/assets/imgs/sad.webp" class="img-fluid w-25 quiz-face-finish" alt="">
                        <p v-if="!quizOk">No has aprobado el cuestionario</p>
                        <p v-if="quizOk">¡Felicitaciones! </p>
                        <p v-if="quizOk">¡Has completado el cuestionario con éxito!</p>

                        <p v-if="!quizOk && okPoints != '0'">Lamentablemente no has podido completar con éxito el cuestionario.</p>
                        <p v-if="!quizOk && okPoints == '0'">Ha Finalizado el tiempo que tenías para realizarlo.</p>

                        <p v-if="quizOk && okPoints == '0'">Has respondido correctamente {{totalQuestionsOk}} preguntas.</p>
                        <p v-if="quizOk && okPoints != '0'">Has obtenido un total de {{userPoints}} puntos.</p>
                        <div v-for="q in questAnswers" :key="q.id" >
                            <p class="mb-1"><i class="las la-check text-success" v-if="q.correct"></i><i class="las la-times text-danger" v-if="!q.correct"></i> {{q.question}}</p>
                        </div>
                        
                        <div class="mt-5 pb-5">
                            <button v-if="!quizOk" class="btn btn-outline-primary btn-sm" @click="resetQuiz()">Volver a intentar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hide-horizontal" v-if="moduleFree == '0'">
            <div class="options-lesson" :class="fullpdf">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-block d-lg-none mt-2">
                                <div class="d-flex justify-content-start align-items-center">
                                    <img :src="profImg" class="img-user" />
                                    <p class="m-0">{{ profName }}</p>
                                </div>
                                <p class="m-0 mt-2">{{moduleName}}</p>
                                <h4 class="titleLesson mb-4 mt-0">{{ titleClass }}</h4>
                            </div>  
                            <div class="d-none d-lg-flex justify-content-between align-items-center mt-4 mb-4">
                                <div>
                                    <p class="m-0">{{moduleName}}</p>
                                    <h3 class="titleLesson mb-0 mt-0">{{ titleClass }}</h3>
                                </div>
                                <div class="d-flex justify-content-start align-items-center">
                                    <img :src="profImg" class="img-user" />
                                    <p class="m-0">{{ profName }}</p>
                                </div>
                            </div>   
                            <div class="description-lesson mb-4" v-html="descriptionPrivate"></div>
                            <div class="mb-5 text-center">
                                <img src="@/assets/imgs/logo-white.png" class="mx-auto mt-5 mb-5" style="width: 152px; filter: brightness(0.5);" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 11000; width: fit-content; ">
        <div id="toastcontainer" class="w-25">
        </div>
    </div>

</template>
<script>
import axios from "axios";
import { Toast } from 'bootstrap';
import { vueVimeoPlayer } from 'vue-vimeo-player'
import VueCountdown from '@chenfengyuan/vue-countdown';
import paymentCart from '@/components/course-show/payment-cart.vue'  
export default {   
    name: "quiz-module",
    props: ['moduleId', 'lessonId', 'couserRef', 'profName', 'profImg', 'moduleName', 'localZone', 'publishTitle', 'bookingId'], 
    data(){
        return{
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            dataReceiver: '',
            quizId: '',
            profId: '',
            durationQuiz: '',
            timeQuiz: 0,
            okPoints: 0,
            questions: [],
            optionsVimeo: { //opciones de vimeo
				muted: true,
                autoplay: false,
                controls: true,
                color: '4586e6',       
			},
            titleClass: '',
            typeClass: 1,
            duration: 0,
            descriptionPrivate: '',
            fullpdf: '',
            classIcon: 'las la-expand-arrows-alt',
            fulltText: 'Agrandar',
            correctQuestion: false,
            userPoints: 0,
            questionPts: 0,
            quizOk: false,
            totalQuestionsOk: 0,
            counterFinish: '',
            isSelected: false,
            questAnswers: [],
            moduleFree: 0,
            profRef: '',  
            realPriceLocal: 0,
            realPriceInter: 0,
        }
    },
    components: {
        vueVimeoPlayer,
        VueCountdown,
        paymentCart,
    },
    mounted: function () {
        if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
            this.dataReceiver = localStorage.getItem('corporativeIn');
        }else{
            this.dataReceiver = localStorage.getItem('token');
        }
        this.findLessonData()
    },
    methods:{
        restCountDown(){
            let now = new Date(); 
            let newDate = new Date(); 
            var sum = (newDate.getMinutes() + parseInt(this.timeQuiz));
            newDate.setMinutes(sum);
            this.counterFinish = (newDate - now);  
        },
        onCountdownEnd(){
            this.quizOk = false;
            var elems = document.querySelectorAll(".selected");
            [].forEach.call(elems, function(el) {
                el.classList.remove("selected");
            });
            var elems = document.querySelectorAll(".in");
            [].forEach.call(elems, function(el) {
                el.classList.remove("in");
            });
            var elems = document.querySelectorAll(".hide");
            [].forEach.call(elems, function(el) {
                el.classList.remove("hide");
            }); 
            document.querySelector('#finish').classList.add("in");
            this.counterFinish = '';
           
        },
        resetQuiz(){
            this.questAnswers = [];
            this.isSelected = false;
            this.questionPts = 0;
            this.userPoints = 0;
            this.quizOk = false;
            this.totalQuestionsOk = 0;
            this.correctQuestion = false;
            var elems = document.querySelectorAll(".selected");
            [].forEach.call(elems, function(el) {
                el.classList.remove("selected");
            });
            var elems = document.querySelectorAll(".in");
            [].forEach.call(elems, function(el) {
                el.classList.remove("in");
            });
            var elems = document.querySelectorAll(".hide");
            [].forEach.call(elems, function(el) {
                el.classList.remove("hide");
            }); 
            try{
                document.querySelector('#initial').classList.add("in");    
            }catch(e){
                
            }     
            this.restCountDown();
        },
        startQuiz(){ 
            try{
                document.querySelector('#initial').classList.add("hide"); 
                var el = document.querySelector('#initial').nextSibling;
                document.querySelector('#'+el.nextSibling.id).classList.add("in");
                this.correctQuestion = false;
            }catch(e){
                
            } 
            this.restCountDown();       
        },
        nextQuestion(val){  
            if(this.isSelected == false){
                this.errorText = 'Debes eleggir una opción.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){
                    
                }
                return;

            } 
            var quest = document.querySelector('#quest-'+val).innerHTML;
            if(this.correctQuestion){
                this.userPoints = (this.userPoints + parseInt(this.questionPts));
                this.totalQuestionsOk++;  
                this.questAnswers.push({'question' : quest, 'correct' : true});
            }else{
                this.questAnswers.push({'question' : quest, 'correct' : false});
            }
            if(this.userPoints >= this.okPoints){
                this.quizOk = true;
                this.isFinish();     
            }
            try{
                document.querySelector('#q-'+val).classList.add("hide"); 
                var el = document.querySelector('#q-'+val).nextSibling;
                document.querySelector('#'+el.id).classList.add("in");
                this.correctQuestion = false;
            }catch(e){
                document.querySelector('#finish').classList.add("in");
                this.counterFinish = '';
            }   
            this.isSelected = false;     
        },
        selectOption(answerId, isCorrect, questionPts){
            this.isSelected = true;
            this.correctQuestion = isCorrect;
            this.questionPts = questionPts;
            var elems = document.querySelectorAll(".selected");
            [].forEach.call(elems, function(el) {
                el.classList.remove("selected");
            });
            try{
                document.querySelector('#a-'+answerId).classList.add("selected"); 
            }catch(e){

            }
        },
        showFullPdf(){
            if(this.fullpdf == ''){
                this.classIcon = 'las la-compress-arrows-alt';
                this.fulltText = 'Achicar';
                this.fullpdf = 'full';
            }else{
                this.classIcon = 'las la-expand-arrows-alt';
                this.fulltText = 'Agrandar';
                this.fullpdf = '';
            }
        },
        isPlaying(){
        },
        isFinish(){
            this.$parent.markReady(this.lessonId, this.moduleId)
        }, 
        async findLessonData(){
            var payload = {
                action: 'find-lesson-data-workshop',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                couserRef: this.couserRef,
                moduleId: this.moduleId,
                lessonId: this.lessonId,
                bookingId: this.bookingId
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.waiting = false;
                this.titleClass = result.data.titleClass;
                this.typeClass = result.data.typeClass;
                this.duration = result.data.duration;       
                this.descriptionPrivate = result.data.descriptionPrivate;
                this.profId = result.data.userId;    
                this.quizId = result.data.quizId; 
                this.realPriceLocal = result.data.realPriceLocal;
                this.realPriceInter = result.data.realPriceInter;
                this.profRef = result.data.userId;
                this.moduleFree = result.data.moduleFree;
                if(this.moduleFree == '1'){
                    this.$parent.hideShowBtnMessage(true);
                }else{
                    this.$parent.hideShowBtnMessage(false);
                } 
                if(window.innerWidth < 592){
                    var a = this;
                    setTimeout(function(){ a.showFullPdf() }, 2000);
                }
                this.findQuizData();
                this.findQuestionData();
            });
        }, 
        async findQuizData(){ 
            this.waiting = true; 
            var payload = {
                action: 'find-quiz-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profId,
                ref: this.quizId
            }
            await axios.post('/index.php', payload)
            .then(result => {
                if(result.data.status == '200'){ 
                    this.okPoints = parseInt(result.data.okPoints); 
                    this.durationQuiz = result.data.duration;
                    this.timeQuiz = result.data.time;
                }   
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){
                    
                }
                return;
            })
        },  

        async findQuestionData(){ 
            this.waiting = true; 
            var payload = {
                action: 'find-all-quiz-question-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profId,
                quizRef: this.quizId,   
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.waiting = false;    
                this.questions = result.data;
                
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){
                    
                }
                return;
            })
        },
        async listQuestionsQuiz(){
            var payload = {
                    action: 'list-user-question-quiz',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.profId,
                    ref: this.quizId
                } 
                await axios.post('/index.php', payload)
                .then(result => { 
                    this.questions = result.data;  
                })
                .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;

            })
        }, 
    }
}
</script>